import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'categoryKitchen/';

const initialState = {
    mappings: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const fetchCategoryKitchens = createAsyncThunk(
    'categoryKitchen/fetchAll',
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(API_URL + 'list');
            return res.data.mappings || [];
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const assignCategoryKitchen = createAsyncThunk(
    'categoryKitchen/assign',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + 'assign', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const bulkAssignCategoryKitchen = createAsyncThunk(
    'categoryKitchen/bulkAssign',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + 'bulkAssign', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const categoryKitchenSlice = createSlice({
    name: 'categoryKitchen',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategoryKitchens.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchCategoryKitchens.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.mappings = action.payload;
            })
            .addCase(fetchCategoryKitchens.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(assignCategoryKitchen.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(assignCategoryKitchen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(assignCategoryKitchen.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(bulkAssignCategoryKitchen.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(bulkAssignCategoryKitchen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(bulkAssignCategoryKitchen.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = categoryKitchenSlice.actions;
export default categoryKitchenSlice.reducer;
